import type { CopyShape } from "@tami/core/intl";

import type { SHEET_COPY_PT_BR } from "../sheet.copy";

export const SHEET_COPY_EN_US: CopyShape<typeof SHEET_COPY_PT_BR> = {
  close: "Close",
};
